export { HeaderWithTabs } from './header-with-tabs';
export type { HeaderWithTabsProps } from './header-with-tabs';
